import React, { useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import { SetterOrUpdater } from "recoil";

const TableFilters = ({
  defaultValue,
  filterText,
  moduleDetails,
  textInputName,
  columnDetails,
  disabledButton,
}: {
  defaultValue?: string,
  filterText: SetterOrUpdater<string>,
  moduleDetails: string,
  textInputName: string,
  columnDetails: string,
  disabledButton: boolean
}) => {
  const [inputValue, setInputValue] = useState(defaultValue ?? "");

  const FilterData = () => {
    filterText(inputValue);
  };
  const DoNothing = () => {};
  return (
    <div className="rounded-lg space-y-4">
      <div className="flex flex-row w-1/2 items-center gap-2">
        <div className="2xl:w-40">
          <TextInput
            type={textInputName === "TermName" ? "Number" : "Text"}
            name={textInputName}
            placeholder={columnDetails}
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
              e.target.value === "" ? filterText("") : DoNothing();
            }}
          />
        </div>
        <SearchButton
          buttonValue="Search"
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            FilterData();
          }}
        />
        <RefreshButton
          className={
            inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={inputValue === "" || disabledButton ? true : false}
          onClick={() => {
            filterText("");
            setInputValue("");
          }}
        />
      </div>
    </div>
  );
};

export default TableFilters;
